

































































































































































































import {
  KeyMapInterface, KeyMaps, UserStateChange,
} from '@battletris/shared';
import { computed, onUnmounted, ref } from '@vue/composition-api';
import { Component, Vue } from 'vue-property-decorator';
import VueSlider from 'vue-slider-component';
import SinglePlayer from '../components/SinglePlayer.vue';
import KeyMapSelect from '../components/KeyMapSelect.vue';
import user from '../lib/User';
import ViewWrapper from '../components/ViewWrapper.vue';

@Component({
  components: {
    SinglePlayer,
    KeyMapSelect,
    ViewWrapper,
    VueSlider,
  },
  setup(props, { root }) {
    const hoveredKey = ref<string | undefined>();
    const keyMaps = ref<KeyMapInterface[]>([
      ...user.keyMaps,
      ...KeyMaps.map((KeyMapClass) => new KeyMapClass()),
    ]);
    const activeKeyMapId = ref(user.activeKeyMap || 'default');
    const controlsList = ref(Object
      .keys(UserStateChange)
      .filter((stateChange) => Number.isNaN(parseInt(stateChange, 10))));
    const activeKeyMap = ref<KeyMapInterface>();

    /** ************************ key map ********************************* */
    const keyMapChanged = (active: string | KeyMapInterface = activeKeyMapId.value) => {
      activeKeyMapId.value = typeof active === 'string' ? active : active.id;
      const selected = keyMaps.value.find(({ id }) => activeKeyMapId.value === id);
      if (selected) {
        activeKeyMap.value = selected;
      }
    };
    keyMapChanged();
    if (!activeKeyMap.value) {
      keyMapChanged('default');
    }
    const addKeyMap = () => {
      const tempId = (keyMaps.value.length - 1).toString(); // generate temporary id
      const newKeyMap: KeyMapInterface = {
        ...activeKeyMap.value,
        id: tempId,
        name: `${root.$i18n.t('laboratory.key-maps.new')} ${tempId}`,
        keys: JSON.parse(JSON.stringify(activeKeyMap.value.keys)),
      };
      keyMaps.value.push(newKeyMap);
      keyMapChanged(newKeyMap.id);
    };
    const removeKeyMap = async () => {
      const activeId = activeKeyMapId.value;
      keyMaps.value.splice(keyMaps.value.findIndex(({ id }) => activeId === id), 1);
      await user.deleteKeyMap(activeId);
      keyMapChanged('default');
    };

    /** ************************ key registration ********************************* */
    const registeringKey = ref<string | undefined>();
    let keyListener;
    const unregisterKey = (controlId: string, keyIndex: number) => {
      if (activeKeyMapId.value === 'default' || activeKeyMapId.value === 'wasd') {
        addKeyMap();
      }

      activeKeyMap.value.keys[UserStateChange[controlId]].splice(keyIndex, 1);
    };
    const registerKey = (control: string) => {
      if (activeKeyMapId.value === 'default' || activeKeyMapId.value === 'wasd') {
        addKeyMap();
      }

      if (keyListener) {
        document.removeEventListener('keyup', keyListener);
      }
      registeringKey.value = control;

      keyListener = (event: KeyboardEvent) => {
        // search for other references and remove this key
        controlsList.value.forEach((key: string) => {
          const controlIdIndex = activeKeyMap.value.keys[UserStateChange[key]].indexOf(event.keyCode);
          if (controlIdIndex !== -1) {
            activeKeyMap.value.keys[UserStateChange[key]].splice(controlIdIndex, 1);
          }
        });
        // add the new key
        activeKeyMap.value.keys[UserStateChange[control]].unshift(event.keyCode);
        registeringKey.value = control;
        registeringKey.value = '';
        document.removeEventListener('keyup', keyListener);
        keyListener = null;
        event.preventDefault();
        event.stopPropagation();
        return false;
      };

      document.addEventListener('keyup', keyListener);
    };

    const disabled = computed(() => activeKeyMapId.value === 'default' || activeKeyMapId.value === 'wasd');

    /** ******************************** game preview logic ************************************* */
    const beforeGameStart = async () => {
      await user.saveKeyMaps(
        activeKeyMapId.value,
        keyMaps.value.filter((keyMap) => keyMap.id !== 'default' && keyMap.id !== 'wasd'),
      );
    };
    // listener for game finished
    onUnmounted(async () => {
      beforeGameStart();
    });

    return {
      activeKeyMap,
      activeKeyMapId,
      addKeyMap,
      beforeGameStart,
      controlsList,
      disabled,
      hoveredKey,
      keyMapChanged,
      keyMaps,
      registeringKey,
      registerKey,
      removeKeyMap,
      unregisterKey,
      UserStateChange,
    };
  },
})
export default class Laboratory extends Vue { }
